(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pedalboard_animation"]) return;
  try {
    

  var v = $('.board_section').offset().top;
  var vh = $(window).height();
  
  $(window).scroll(function() {
    let value = $(window).scrollTop();

    if (value + v < 600 + v ) {
      $('#text').css("font-size", 50 - value / 15 + "vw");
    }
    
    if (value + v > v + 150) {
      $('#p1').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/1.png");
    }
    if (value + v > v + 200) {
      $('#p2').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/2_1e8f060c-7f25-4ade-bfa0-03c63c2b7a36.png");
    }
    if (value + v > v + 250) {
      $('#p3').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/3_e8a4499c-e6bb-4ff8-bb2f-7e03fa29ce3b.png");
    }
    if (value + v > v + 300) {
      $('#p4').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/4.png");
    }
    if (value + v > v + 350) {
      $('#p5').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/5.png");
    }
    if (value + v > v + 400) {
      $('#p6').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/6.png");
    }
    if (value + v > v + 450) {
      $('#p7').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/7.png");
    }
    if (value + v > v + 500) {
      $('#p8').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/8.png");
    }
    if (value + v > v + 550) {
      $('#p9').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/9.png");
    }
    if (value + v > v + 600) {
      $('#p10').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/10.png");
    }

    if (value + v < v + 150) {
      $('#p1').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p1.png");
    }
    if (value + v < v + 200) {
      $('#p2').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p2.png");
    }
     if (value + v < v + 250) {
      $('#p3').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p3.png");
    }
     if (value + v < v + 300) {
      $('#p4').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p4.png");
    }
     if (value + v < v + 350) {
      $('#p5').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p5.png");
    }
     if (value + v < v + 400) {
      $('#p6').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p6.png");
    }
     if (value + v < v + 450) {
      $('#p7').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p7.png");
    }
     if (value + v < v + 500) {
      $('#p8').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p8.png");
    }
     if (value + v < v + 550) {
      $('#p9').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p9.png");
    }
     if (value + v < v + 600) {
      $('#p10').attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/p10.png");
    }

    console.log("by 15 value: " + value + "v: " + v + "vh: " + vh + "WORK");
  });




  
  $('#pedalboard').hover(function() {
    $(this).attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/PedalboardTogether.jpg");
  }, function() {
    $(this).attr("src", "https://cdn.shopify.com/s/files/1/2476/2680/files/PedalboardSplit.jpg");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
